export function NotFoundPage() {
  return <div>Page not found</div>
}
